import {useCallback, useContext} from "react";
import {AppDataContext} from "../../App";
import axios from "axios";
import _ from "lodash";
import { getAuth } from "firebase/auth"

const UseApiManager = () => {

    const { state } = useContext(AppDataContext)

    const getToken = () => {
        return new Promise((resolve) => {
            if (!getAuth().currentUser) { return resolve(null)}
            getAuth().currentUser.getIdToken()
                .then(resolve)
                .catch(() => resolve(null))
        })
    }

    /**
     *
     * @type {function(string, string, object): Promise<[object]>}
     */
    const Req = useCallback((method, path, options) => {
        return new Promise(async (resolve, reject) => {
            console.log(options)
            const token = await getToken()
            if (token) {
                options = _.merge(options, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
            }

            const url = path.startsWith('/') ? path : `/${path}`
            axios({
                method,
                url,
                baseURL: state.apiEndpoint,
                ...options
            }).then(res => {
                if (options.isRawResponse) {
                    return resolve(res)
                }
                if (_.isNil(res.data)) {
                    return reject('Response data empty')
                }
                if (!res.data.result) {
                    return reject(res.data?.message)
                }
                if (_.isNil(res.data.rows)) {
                    return reject('Invalid response data')
                }
                if (_.isEmpty(res.data.rows)) {
                    return resolve(null)
                }
                resolve(res.data.rows)
            }).catch(reject)
        })
    }, [state.apiEndpoint])

    const Get = (path, params, options) =>
        Req("get", path, { ...options, params })

    const GetFirst = async (path, params, options) =>
        _.first(await Get(path, params, options))

    const GetOne = async (path, params, options) =>
        _.first(_.values(await GetFirst(path, params, options)))

    const Post = (path, data, options) =>
        Req("post", path, { ...options, data, })

    const PostFirst = async (path, data, options) =>
        _.first(await Post(path, data, options))

    const PostOne = async (path, data, options) =>
        _.first(_.values(await PostFirst(path, data, options)))

    const Put = (path, data, options) =>
        Req("put", path, { ...options, data })

    const PutFirst = async (path, data, options) =>
        _.first(await Put(path, data, options))

    const PutOne = async (path, data, options) =>
        _.first(_.values(await PutFirst(path, data, options)))

    const Delete = (path, data, options) =>
        Req("delete", path, {...options, data})

    const DeleteFirst = async (path, data, options) =>
        _.first(await Delete(path, data, options))

    const DeleteOne = async (path, data, options) =>
        _.first(_.values(await DeleteFirst(path, data, options)))

    const QueryVectorTreeTileUrl = useCallback(params => {
        return new Promise((resolve, reject) => {
            PostFirst("tree/tile", params)
                .then(res => {
                    let tileUrl = state.env.CLIENT_VECTOR_TILE_ENDPOINT
                        .replace("{layerId}", res.id)
                        .replace("{apiKey}", state.env.CLIENT_API_KEY)
                    resolve(tileUrl)
                })
                .catch(reject)
        })
    }, [state.env])

    const QueryVectorTileUrl = useCallback((sql) => {
        return new Promise(async (resolve, reject) => {
            let row = await PostFirst("tile", {sql})
                .catch(reject)
            let tileUrl = state.env.CLIENT_VECTOR_TILE_ENDPOINT
                .replace("{layerId}", row.id)
                .replace("{apiKey}", state.env.CLIENT_API_KEY)
            resolve(tileUrl)
        })
    }, [state.env])

    return {
        Req,
        Get,
        GetFirst,
        GetOne,
        Post,
        PostFirst,
        PostOne,
        Put,
        PutFirst,
        PutOne,
        Delete,
        DeleteFirst,
        DeleteOne,
        QueryVectorTreeTileUrl,
        QueryVectorTileUrl,
    }

}

export default UseApiManager
